import React, { useEffect } from 'react'
import { useNavigate } from "react-router-dom"


function Auth({ showAuth, toggleAuth, socket, user, actionsAfterAuth, setActionsAfterAuth }) {
    const s = socket.socket
    const navigate = useNavigate()
    
    useEffect(()=>{
        if( user ){
            toggleAuth()
            if( actionsAfterAuth.linkPath ){
                navigate( actionsAfterAuth.linkPath )
            }
            if( actionsAfterAuth.func ){
                if( actionsAfterAuth.funcProp ){
                    actionsAfterAuth.func( actionsAfterAuth.funcProp, user )
                    setActionsAfterAuth( { linkPath : null, func : null, funcProp : null } )
                }else{
                    actionsAfterAuth.func()
                    setActionsAfterAuth( { linkPath : null, func : null, funcProp : null } )
                }
            }
        } 
    }, [ user, actionsAfterAuth ])


    const handleFBLogin = () => {
        try{
            window.FB.login(( response ) => {
                if ( response ) {
                    window.FB.api('/me?fields=first_name, email, picture.width(250)', function( data ) {
                        if( data.email && data.first_name && data.id ) s.emit( 'loadOrCreate', data )
                    });
                    // User is logged in, handle the response (e.g., get access token)
                    // console.log( 'Logged in:', response );
                } else {
                    // User canceled login or didn't authorize
                    // console.log( 'Login canceled' );
                }
                }, { scope: 'public_profile,email' }); // Request necessary permissions
        }catch(e){
            console.log( e )
        }
    };

    

    return(
        <div className={`authWrapper ${showAuth ? 'visible' : 'invisible'}`}>
            <div className='loginContentHolder'>
                {/* <div className="nicknameInputHolder">
                    <input 
                        type="text" 
                        className="input nicknameInput" 
                        placeholder="Enter your nickname" 
                    />
                    <button className="purple_button nicknameButton">
                        Submit
                    </button>
                </div> */}
                {/* <div className='fbLoginButtonHolder' >
                    <button className='fbLoginButton' onClick={ handleFBLogin }>
                        <svg className='buttonIcon' viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.5 12.0441C24.5 5.39234 19.1274 -6.33409e-07 12.5 -6.33409e-07C5.87259 -6.33409e-07 0.5 5.39234 0.5 12.0441C0.5 17.6925 4.37432 22.432 9.60109 23.7335V15.7246H7.12659V12.0441H9.60109V10.4582C9.60109 6.35876 11.4495 4.45868 15.4594 4.45868C16.2196 4.45868 17.5314 4.60827 18.068 4.7579V8.09431C17.7848 8.0644 17.2929 8.04941 16.6817 8.04941C14.714 8.04941 13.9538 8.7975 13.9538 10.7425V12.0441H17.8734L17.2001 15.7246H13.9538V24C19.8955 23.2797 24.5 18.2019 24.5 12.0441Z" fill="white"/>
                        </svg>
                        <p>Continue with Facebook</p>
                    </button>
                    <button className="secondary_button" onClick={()=>{ toggleAuth() }}><p>Close</p></button>
                </div> */}
                <svg className='authBackLight' viewBox="0 0 852 1415" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M852 506.989C852 1008.46 661.273 1414.99 426 1414.99C190.727 1414.99 0 1008.46 0 506.989C0 5.5145 190.727 0 426 0C661.273 0 852 5.5145 852 506.989Z" fill="url(#paint0_radial_975_1311)"/>
                    <defs>
                    <radialGradient id="paint0_radial_975_1311" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(426 545.829) rotate(90) scale(869.171 407.783)">
                    <stop offset="0.06" stopColor="#002863"/>
                    <stop offset="0.975" stopColor="#001431" stop-opacity="0"/>
                    </radialGradient>
                    </defs>
                </svg>
            </div>
        </div>
    )
}

export default Auth
